export default __webpack_public_path__ + "static/media/1395.ec3cda6e.png";